import { DOC_TYPE, FILE_FORMAT, FILE_TYPE } from '../config/constants';

export const getFileType = (file: File): string => {
  if (file?.type?.startsWith('image/')) {
    return FILE_FORMAT.IMAGE;
  } else if (file?.type?.startsWith('video/')) {
    return FILE_FORMAT.VIDEO;
  } else if (file?.type === 'application/pdf') {
    return FILE_FORMAT.PDF;
  } else {
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (extension === 'heic' || extension === 'heif') {
      return FILE_FORMAT.IMAGE;
    }
    return FILE_FORMAT.OTHER;
  }
};

const getFileExtension = (filename: string): string => {
  return filename.toLowerCase().slice(filename.lastIndexOf('.'));
};

export const handleFile = (file: File, isGalleryView = false): boolean => {
  const extension = getFileExtension(file.name);
  type FileExtension = (typeof FILE_TYPE)[keyof typeof FILE_TYPE];
  type DocExtension = (typeof DOC_TYPE)[keyof typeof DOC_TYPE];
  if (isGalleryView) {
    return Object.values(FILE_TYPE).includes(extension as FileExtension);
  } else {
    return Object.values(DOC_TYPE).includes(extension as DocExtension);
  }
};

export const getFileSizeInMB = (sizeInBytes: number): string => {
  const fileSizeInMB = sizeInBytes / (1024 * 1024);
  if (fileSizeInMB < 1) {
    const fileSizeInKB = sizeInBytes / 1024;
    if (fileSizeInKB < 1) {
      return sizeInBytes.toFixed(3) + ' B';
    }
    return fileSizeInKB.toFixed(3) + ' KB';
  }
  return fileSizeInMB.toFixed(0) + ' MB';
};

export const convertBytesToMB = (bytes: number): number => {
  return bytes / (1024 * 1024);
};

export const formatToMMDDYYYY = (date: Date | null): string => {
  if (!date) {
    return '';
  }

  const formatter = new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });

  return formatter.format(date);
};



export const getIconName = (extension: string): string => {
  switch (extension) {
    case '.pdf':
      return 'pdf';
    case '.docx':
      return 'word';
    case '.xlsx':
      return 'excel';
    case '.xls':
      return 'excel';
    case '.txt':
      return 'text';
    case '.csv':
      return 'excel';
    case '.doc':
      return 'word';
    case '.bmp':
      return 'placeholder-image'
    default:
      return 'text';
  }
}

export const getCompressionQuality = (fileSize: number): number => {
  const sizeMB = fileSize / (1024 * 1024);
  if (sizeMB > 18) return 0.4;
  if (sizeMB > 12) return 0.5;
  if (sizeMB > 7) return 0.6;
  if (sizeMB > 3) return 0.7;
  return 0.8;
}

